export default {
	project: {
		my_xs: '我的决策',
		fields: {
			name: '标题',
			name_explanation: '为项目填写标题',
			description: '使命',
			description_explanation: '说明总体使命',
			vision: '愿景',
			vision_explanation: '阐述项目的长期愿景',
			description_long: '描述',
			description_long_explanation: '例如：「瑞士机电一体化中小企业，200人，欧洲汽车OEM市场。使命：到2030年成为欧洲智能传感器领导者。」',
			description_long_hint: '描述越准确（行业、规模、使命），分析就越精确。',
			description_long_warning_title: '描述过于简短',
			description_long_warning_body: '您的描述只有 {{count}} 个字符。AI 可能会推断出与您的组织不符的行业或场景。是否在启动前补充更多信息？',
			description_long_warning_enrich: '补充内容',
			description_long_warning_continue: '仍然启动',
			ai_context: '关注重点与切入角度',
			ai_context_explanation: '指明分析应优先关注的角度、相关方或约束（如某个特定竞争对手、监管维度、地理范围、时间约束等）。',
			fishbone_description: '战略计划 - 目标状态',
			fishbone_description_explanation: '',
			reference: '参考编号',
			tags: '标签',
			likelihoods: '可能性',
			impacts: '影响',
			types: {
				stakeholders: '利益相关方',
				stakeholders_long: '利益相关方项目',
				stakeholders_explanation: '协调各方力量',
				risks: '风险',
				risks_long: '风险项目',
				risks_explanation: '将风险转化为突破口',
				pro: '战略执行',
				pro_long: '战略执行项目',
				pro_explanation: '敏捷落地'
			},
			ai: {
				scenarios: {
					title: "待探索的场景",
					hint: "由私有 AI 处理 — 无外发数据。可编辑文本、时间跨度，新增或移除。",
					worst_label: "最坏情况",
					worst_default: "主要风险发生，机会错失，利益相关方反对。",
					best_label: "最佳情况",
					best_default: "风险得到管控，机会被把握，利益相关方协作。",
					add: "新增场景",
					remove: "移除此场景",
					label_placeholder: "场景名称",
					content_placeholder: "假设、关键事件、实现条件…"
				},
				horizon_unit: {
					d: "天",
					w: "周",
					m: "月",
					y: "年"
				}
			},
		},
		messages: {
			delete_confirmation: '删除项目',
			delete_confirmation_explanation:
				'确定要删除项目「{{name}}」吗？此操作不可撤销。',
			clone_confirmation: '克隆项目',
			clone_confirmation_explanation: '确定要克隆此项目吗？',
			clone_in_progress: '正在克隆项目，请稍候…',
			delete_in_progress: '正在删除项目，请稍候…'
		},
		actions: {
			edit: '编辑项目详情',
			delete: '删除项目',
			clone: '克隆项目',
			open: '打开项目'
		}
	},
	option: {
		fields: {
			name_explanation: '请为此选项输入名称'
		}
	},
	item: {
		name: '利益相关方',
		name_plural: '利益相关方',
		activeness_zones: {
			external_outer_positive: '中性',
			external_inner_positive: '不活跃',
			external_outer_negative: '中性',
			external_inner_negative: '不活跃',
			internal_low_positive: '低',
			internal_medium_positive: '中',
			internal_high_positive: '高',
			internal_low_negative: '低',
			internal_medium_negative: '中',
			internal_high_negative: '高',
			internal_positive: '催化剂',
			internal_negative: '抑制因素'
		},
		messages: {
			delete_confirmation: '删除利益相关方',
			delete_confirmation_explanation:
				'确定要删除此利益相关方吗？不可撤销，且将影响所有场景。\n\n若仅想在本场景中隐藏，请关闭本窗口，选中该方，在右栏点击「眼睛」图标以在本场景停用。'
		},
		fields: {
			name: '名称',
			description: '描述',
			links: {
				outcoming: { name: '出站关联' },
				incoming: { name: '入站关联' }
			},
			stakes: { name: '利害关系关联' },
			indicators: { name: '指标关联' },
			risks: { name: '风险关联' },
			opportunities: { name: '突破口关联' },
			impact: {
				label: '重要性',
				level: { low: '低', medium: '中', high: '高' }
			},
			trend: {
				label: '基调',
				level: {
					green: '正面',
					neutral: '中性',
					orange: '有风险',
					red: '负面'
				}
			}
		},
		actions: {
			create_new: '新建利益相关方',
			edit: '编辑详情',
			delete: '删除利益相关方',
			clone: '克隆利益相关方'
		},
		no_x: '无利益相关方',
		engagement: '参与度',
		importance: '重要性',
		trust: '基调',
		levels: {
			low: '低',
			medium: '中',
			high: '高',
			inactive_neutral: '不活跃 / 中性',
			positive: '正面',
			positive_short: '正面',
			negative: '负面',
			negative_short: '负面',
			at_risk: '有风险',
			neutral: '中性'
		}
	},
	item_link: {
		no_x: '无关联',
		actions: { create_new: '新建关联' }
	},
	item_comment: {
		no_x: '无历史',
		actions: { create_new: '新建历史记录' }
	},
	tag: {
		name: '标签',
		name_plural: '标签',
		fields: { name: '标签', name_plural: '标签' },
		messages: {
			delete_confirmation: '删除标签',
			delete_confirmation_explanation: '确定要删除此标签吗？不可撤销。',
			no_x: '无标签'
		},
		actions: {
			add_x: '添加标签',
			create_new: '创建标签',
			edit: '编辑标签',
			delete: '删除标签'
		}
	},
	stake: {
		no_x: '无利害关系',
		name: '利害关系',
		name_plural: '利害关系',
		fields: {
			name: '名称',
			reference: '参考编号',
			name_plural: '利害关系',
			description: '描述',
			evaluated_at: '最近评估',
			weight: '权重',
			trend: '状态',
			risks: { name: '风险关联', name_positive: '突破口关联' },
			trend_tier: { strained: '脆弱', mixed: '混合', solid: '稳健' }
		},
		message: { no_x: '无利害关系' },
		messages: {
			delete_confirmation: '删除利害关系',
			delete_confirmation_explanation:
				'确定要删除此利害关系吗？不可撤销，且将影响所有场景。\n\n若仅想在本场景中隐藏，请关闭，选中该项，在右栏点击「眼睛」图标停用。'
		},
		actions: {
			delete: '删除利害关系',
			edit: '编辑利害关系',
			create_new: '新建利害关系'
		}
	},
	indicator: {
		name: '指标',
		name_plural: '指标',
		no_x: '无指标',
		fields: {
			indicator_category: '类别',
			name: '名称',
			reference: '参考编号',
			name_plural: '指标',
			evaluated_at: '最近评估',
			frequency: '频率',
			weight: '权重',
			description: '描述'
		},
		action: { add_x: '添加指标点' },
		message: { no_x: '无指标' },
		messages: {
			delete_confirmation: '删除指标',
			delete_confirmation_explanation:
				'确定要删除此指标吗？不可撤销，且将影响所有场景。\n\n若仅想在本场景中隐藏，请关闭，选中该项，在右栏点击「眼睛」图标停用。'
		},
		actions: {
			delete: '删除指标',
			edit: '编辑指标',
			create_new: '新建指标'
		}
	},
	scenario: {
		name: '场景',
		name_plural: '场景',
		no_x: '无场景',
		baseline: '基线',
		fields: {
			name: '名称',
			name_long: '场景名称',
			score: '场景得分',
			description: '描述',
			impacts: '影响说明',
			generate_simulation: '自动生成模拟',
			simulation_query: '假设与时间范围'
		},
		placeholders: {
			simulation_query:
				'例如：若两年内油价上涨 50% 会怎样？对利益相关方与已识别风险有何影响？'
		},
		messages: {
			delete_confirmation: '删除场景',
			delete_confirmation_explanation: '确定要删除此场景吗？不可撤销。',
			switch_scenario: '切换到基线或其他场景',
			creation_in_progress: '正在准备场景，请稍候…',
			simulation_explanation:
				'AI 将分析您的假设，并建议修改项目中的利益相关方、风险与利害关系以模拟该场景。',
			promote_as_baseline: {
				title: '将此场景提升为新基线',
				explanation:
					'确定要将场景「<0>{{name}}</0>」提升为新基线吗？不可撤销。',
				keep_current_baseline_as_scenario_question: '如何处理原基线？',
				keep_current_baseline_as_scenario_question_yes: '保留并命名为',
				keep_current_baseline_as_scenario_question_no: '不保留，可删除',
				keep_scenario_question: '是否保留已提升为基线的原场景副本？',
				keep_scenario_question_yes: '是，保留副本',
				keep_scenario_question_no: '否，不需要',
				loading: '正在将场景提升为新基线…'
			},
			best_evaluation: '所有场景中的最佳情况'
		},
		actions: {
			create_new: '新建场景',
			create_new_from_baseline: '从基线新建场景',
			save_as_new_baseline: '另存为新基线',
			clone: '克隆场景',
			edit: '编辑场景',
			delete: '删除场景',
			next: '下一场景',
			previous: '上一场景',
			previous_baseline: '返回基线场景'
		}
	},
	fishbone_branch: {
		name: '大骨',
		name_plural: '大骨',
		fields: {
			completion: '完成度',
			trend: '状态',
			name: '名称',
			description: '描述',
			weight: '权重',
			responsible: '负责人',
			dates: '日期',
			startOn: '开始',
			endOn: '结束'
		},
		messages: {
			delete_confirmation: '删除鱼骨分支',
			delete_confirmation_explanation:
				'确定要删除此分支吗？不可撤销，且将影响所有场景。\n\n若仅想在本场景中隐藏，请关闭，选中分支，在右栏点击「眼睛」图标停用。'
		},
		actions: {
			add: '添加大骨',
			clone: '克隆大骨',
			edit: '编辑大骨',
			delete: '删除大骨'
		}
	},
	fishbone_item: {
		name: '子骨',
		name_plural: '子骨',
		fields: {
			name: '名称',
			description: '描述',
			completion: '完成度',
			trend: '状态',
			weight: '权重',
			responsible: '负责人',
			startOn: '开始',
			endOn: '结束',
			dates: '日期'
		},
		messages: {
			delete_confirmation: '删除子骨',
			delete_confirmation_explanation:
				'确定要删除此措施吗？不可撤销，且将影响所有场景。\n\n若仅想在本场景中隐藏，请关闭，选中措施，在右栏点击「眼睛」图标停用。'
		},
		actions: {
			add: '添加子骨',
			clone: '克隆子骨',
			edit: '编辑子骨',
			delete: '删除子骨'
		}
	},
	risk: {
		name: '风险',
		name_plural: '风险',
		name_positive: '突破口',
		name_plural_positive: '突破口',
		fields: {
			name: '名称',
			description: '描述 - 发生迹象',
			reference: '参考编号',
			risk_category: '类别',
			likelihood: '可能性',
			likelihood_level: '可能性等级名称',
			impact: '影响',
			impact_level: '影响等级名称',
			matching_opportunity: '对应突破口',
			matching_risks: '对应风险',
			evaluated_at: '最近评估',
			exposure: '暴露',
			exposure_positive: '上行空间',
			opportunity: { name: '突破口' }
		},
		impacts: {
			1: '可忽略',
			2: '轻微',
			3: '中等',
			4: '重大',
			5: '极端'
		},
		likelihoods: {
			1: '极不可能',
			2: '不太可能',
			3: '可能',
			4: '较可能',
			5: '几乎确定'
		},
		messages: {
			delete_confirmation: '删除风险',
			delete_confirmation_explanation:
				'确定要删除此风险吗？不可撤销，且将影响所有场景。\n\n若仅想在本场景中隐藏，请关闭，选中风险，在右栏点击「眼睛」图标停用。',
			delete_opening: '删除突破口',
			delete_opening_explanation:
				'确定要删除此突破口吗？不可撤销，且将影响所有场景。\n\n若仅想在本场景中隐藏，请关闭，选中突破口，在右栏点击「眼睛」图标停用。',
			no_x: '无风险',
			no_category: '无类别',
			no_x_positive: '无突破口'
		},
		actions: {
			create_new: '新建风险或突破口',
			edit: '编辑风险',
			edit_opportunity: '编辑突破口',
			delete: '删除风险',
			delete_opportunity: '删除突破口'
		}
	},
	risk_category: {
		name: '类别',
		name_plural: '类别',
		fields: { name: '名称' },
		messages: {
			delete_confirmation: '删除类别',
			delete_confirmation_explanation: '确定要删除此类别吗？不可撤销。',
			no_x: '无类别'
		},
		default_values: {
			name: {
				1: '存亡级',
				2: '战略级',
				3: '运营级'
			}
		},
		actions: {
			create_new: '新建类别',
			edit: '编辑类别',
			delete: '删除类别',
			add_x: '添加类别'
		}
	},
	indicator_category: {
		name: '类别',
		name_plural: '类别',
		fields: { name: '名称' },
		messages: {
			delete_confirmation: '删除类别',
			delete_confirmation_explanation: '确定要删除此类别吗？不可撤销。',
			no_x: '无类别',
			unassigned: '未分配'
		},
		default_values: {
			name: {
				1: '财务',
				2: '客户',
				3: '内部流程',
				4: '学习与成长'
			}
		},
		actions: {
			create_new: '新建类别',
			edit: '编辑类别',
			delete: '删除类别',
			add_x: '添加类别'
		}
	},
};
